/**
 * PWD — iPad Landscape Enforcement (module-safe version)
 * iPads must use landscape mode for proper table/form layout.
 * Injects an overlay nudge if portrait is detected.
 *
 * Converted from IIFE in site/js/ipad-landscape.js for Vite module import.
 * Behavior is identical — runs once on import.
 */
var isIPad = /iPad/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (isIPad) {
  var style = document.createElement('style');
  style.textContent = '@media screen and (orientation:portrait){#pwd-rotate-overlay{display:flex!important}}@media screen and (orientation:landscape){#pwd-rotate-overlay{display:none!important}}';
  document.head.appendChild(style);

  function injectOverlay() {
    if (document.getElementById('pwd-rotate-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'pwd-rotate-overlay';
    overlay.setAttribute('style', 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(10,20,40,0.97);z-index:99999;flex-direction:column;align-items:center;justify-content:center;color:#fff;font-family:system-ui,sans-serif;text-align:center;padding:2rem');
    overlay.innerHTML = '<div style="font-size:4rem;margin-bottom:1rem">&#8635;</div><div style="font-size:1.4rem;font-weight:600;margin-bottom:0.5rem">Please rotate your iPad</div><div style="font-size:1rem;opacity:0.7">Prestige World Drive works best in landscape mode</div>';
    document.body.appendChild(overlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectOverlay);
  } else {
    injectOverlay();
  }
}
